<template>
  <div class="card1" no-body>
    <b-row class="mt-3 pb-0 ">
      <b-col>
        <div>
          <div id="displayOptions">
            <div class="d-block">
              <div class="d-inline-block float-md-left mr-1 align-top mb-1">
                <b-button class="btn-light mr-2 no-shadow" @click="sendUpdate">
                  <i class="lni lni-reload font-size-11 mr-0"></i>
                </b-button>
                <label class="form-group mt-0">
                  <b-form-input
                                style="height: 46px"
                                type="text"
                                class="form-control data-search-form-control"
                                v-model="search"
                                placeholder="search..." />
                </label>
              </div>
            </div>

            <div class="float-md-right mb-3 mb-md-0">
              <b-button-group>
                <!-- sort -->
                <b-dropdown right variant="light" menu-class="bg-white">
                  <template v-slot:button-content>
                    <i class="lni lni-arrow-up" v-if="sort.order == 'asc'"></i>
                    <i
                       class="lni lni-arrow-down"
                       v-if="sort.order == 'desc'"></i>
                    {{ sort.label.replace("Desc", "").replace("Asc", "") }}
                  </template>
                  <b-dropdown-item v-for="(order, index) in sortOptions" :key="index" @click="changeOrderBy(order)">
                    <i class="lni lni-arrow-up" v-if="order.order == 'asc'"></i>
                    <i class="lni lni-arrow-down" v-if="order.order == 'desc'"></i>
                  
                    <span :class="{
                      'text-primary': order.label == defaultSort.label,
                    }">
                      {{ order.label.replace("Desc", "").replace("Asc", "") }}
                    </span>

                  </b-dropdown-item>
                </b-dropdown>

                <!-- filter -->
                <b-dropdown right variant="light" menu-class="bg-white" v-if="filterOptions.length > 0">
                  <template v-slot:button-content>
                    <i class="lni lni-funnel"></i>
                  </template>

                  <div class="p-1">
                    <b-form-input v-model="searchFilter" class=" form-control-sm"
                                  placeholder="Filter Options"></b-form-input>
                  </div>

                  <span v-for="(f, index) in filterOptions" :key="index">
                    <b-dropdown-item right @click="changeFilterBy(f)" v-if="f.column != 'group-heading' && f.hidden != true">
                      {{ f.label }}
                    </b-dropdown-item>

                    <b-dropdown-header class="bg-light text-small" id="dropdown-header-label"
                                       v-if="f.column == 'group-heading'">
                      {{ f.label.toUpperCase() }}
                    </b-dropdown-header>
                  </span>
                </b-dropdown>

                <!-- paginate -->
                <b-dropdown right :text="`${currentRowsPerPage}`" variant="light" menu-class="bg-white">
                  <b-dropdown-item v-for="(size, index) in pageSizes" :key="index" @click="changePageSize(size)">{{ size
                    }}</b-dropdown-item>
                </b-dropdown>
              </b-button-group>

              <slot name="header-buttons"></slot>
            </div>
          </div>
        </div>
        <div style="clear: both"></div>
      </b-col>
    </b-row>

    <div class="row" v-if="filters != []">
      <div class="col">
        <b-button variant="warning" class="btn-sm mr-1 mb-1" v-for="(filter, index) in filters" :key="index"
                  @click="deleteFilterBy(filter)">
          {{ filter.label }} <i class="lni lni-cross-circle"></i>
        </b-button>
      </div>
    </div>

    <b-row>
      <b-col>
        <div v-if="isLoad" class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>

        <div v-if="!isLoad">
          <div class="
              card
              bg-dark
              no-round
              text-white text-uppercase
              font-size-11
              no-border no-shadow
              mb-1
            ">
            <div class="card-body p-3 p-lg-2 font-weight-bold">
              <div class="row">
                <slot name="headings"></slot>
              </div>
            </div>
          </div>

          <div v-for="(item, index) in items" :key="item.id">
            <div class="no-round px-2 px-lg-1 py-2 mt-1 bg-white" style="border: solid 1px var(--bg-light)" :class="{
              'bg-white': index % 2 == 0,
              'bg-white': index % 2 == 1,
              'border-danger': item.danger == true,
            }">
              <div class="row">
                <slot name="rows" v-bind:item="item"></slot>
              </div>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>

    <b-row class="my-3">
      <b-col md="6" class="text-center text-md-left" v-if="lastPage > 1">
        <b-pagination @change="
          currentPage = $event;
        updatePagination();
        " v-model="currentPage" :total-rows="totalRows" :per-page="currentRowsPerPage"
                      aria-controls="my-table"></b-pagination>
      </b-col>
      <b-col md="6 text-center text-md-right pt-2">
        <span class="text-black-50 font-size-13">Showing {{ fromRow }} to {{ toRow }} of {{ totalRows }}</span>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    isLoad: {
      type: Boolean,
      default: false,
    },
    sort: {
      type: Object,
    },
    sortOptions: {
      type: Array,
      default: function () {
        return [];
      },
    },
    filterOptions: {
      type: Array,
      default: function () {
        return [];
      },
    },
    items: {
      type: Array,
      default: function () {
        return [];
      },
    },
    page: {
      type: Number,
      default: 1,
    },

    fromRow: {
      type: Number,
    },
    toRow: {
      type: Number,
    },
    totalRows: {
      type: Number,
    },
    lastPage: {
      type: Number,
    },
  },

  data() {
    return {
      defaultSort: this.sort,
      currentPage: 1,
      currentRowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 12,
      filters: [],
      search: "",
      pageSizes: [12, 24, 48, 96],
      searchFilter: "",
    };
  },

  methods: {
    sendUpdate() {
      //filter string
      let filterStr = null;
      if (this.filters.length > 0) {
        filterStr = `{"filters":[`;
        this.filters.forEach((f, i) => {
          filterStr += JSON.stringify(f);
          if (i != this.filters.length - 1) {
            filterStr += ",";
          }
        });
        filterStr += `]}`;
      }

      this.$emit("updateData", {
        page: this.currentPage,
        rowsPerPage: this.currentRowsPerPage,
        sort: this.defaultSort,
        search: this.search,
        filters: filterStr,
      });
    },

    updatePagination() {
      this.sendUpdate();
    },
    changePageSize(perPage) {
      this.currentRowsPerPage = perPage;
      localStorage.setItem("rowsPerPage", perPage);
      this.sendUpdate();
    },
    changeOrderBy(sort) {
      this.defaultSort = sort;
      this.sendUpdate();
    },
    changeFilterBy(filter) {
      this.searchFilter = ""
      //remove if another filter on column exist
      this.filters = this.filters.filter((f) => f.column != filter.column);

      this.filters.push(filter);

      this.sendUpdate();
    },
    deleteFilterBy(filter) {
      this.filters = this.filters.filter((f) => {
        if (f.column != filter.column) {
          return true;
        } else {
          if (f.value != filter.value) {
            return true;
          }
        }
        return false;
      });
      this.sendUpdate();
    },
    searchQuery() {
      clearTimeout(this.delayTimer);
      this.delayTimer = setTimeout(() => {
        this.page = 1;
        this.sendUpdate();
      }, 500);
    },
    searchFilterQuery() {

      this.filterOptions.forEach(x => {

        x.hidden = false;

        if (this.searchFilter != "") {
          if (x.label.toLowerCase().includes(this.searchFilter.toLowerCase()) || x.column == 'group-heading') {
            x.hidden = false;
          } else {
            x.hidden = true;
          }
        }

      })
    },
  },

  watch: {
    search() {
      this.searchQuery();
    },
    searchFilter() {
      this.searchFilterQuery();
    },
  },
};
</script>
